<template>
  <a-card :bordered='false'>
    <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="currentFormLayout2.labelCol"
                  :wrapper-col="currentFormLayout2.wrapperCol">
      <a-form-model-item label="积分状态" required>
        <a-switch checked-children="开" un-checked-children="关" v-model="ruleForm.open"/>
      </a-form-model-item>
      <a-form-model-item label="集满积分设置" prop="fullPoints">
        <a-input v-model.trim="ruleForm.fullPoints" :maxLength="20" style="width:400px;" allowClear
                 placeholder="请输入集满积分"></a-input>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">保存设置
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import GuWeiMixins from '@/views/service/serviceProvider/guWei/mixins/GuWeiMixins'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'

export default {
  name: 'GuWeiSetting',
  mixins: [GuWeiMixins, ruleFormMixins],
  components: {},
  props: {},
  data() {
    return {
      submitLoading: false,
      ruleForm: {
        fullPoints: '',//集满积分设置
        open: false//是否开启古维助手 0=未开启、1=开启
      },
      rules: {
        fullPoints: [
          { required: true, message: '请输入集满积分', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是正整数', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getSettingDetail()
  },
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.open = params.open ? 1 : 0
      params.merchantId = this.$store.getters.userInfo.merchantId// 商户ID ,
      params.platformId = this.getPlatformConfig().platformId// 平台ID ,
      this.getHttpServices().getServerApiService().post('api/gw/setting/save', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('设置成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getSettingDetail() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,// 商户ID ,
        platformId: this.getPlatformConfig().platformId// 平台ID ,
      }
      this.getHttpServices().getServerApiService().post('api/gw/setting/detail', params).then(res => {
        this.ruleForm = { ...res }
        this.ruleForm.open = res.open == 1 ? true : false
      }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    }
  }
}
</script>

<style scoped lang='less'>

</style>
